
import { NgModule } from '@angular/core';
import { SiriusAppModule } from 'sirius-framework';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/modules/shared.module';
import { InnerMenuLiveProcessRoutingModule } from './inner-menu-liveprocess.routing.module';

import { InnerMenuLiveProcessComponent } from './inner-menu-liveprocess.component';
import { LiveProcessComponent } from './components/liveprocess/liveprocess.component';

import { InnerMenuLiveProcessService } from './inner-menu-liveprocess.service'; 

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        InnerMenuLiveProcessRoutingModule       
    ],
    declarations: [
        InnerMenuLiveProcessComponent,
        LiveProcessComponent
    ],
    providers: [
        InnerMenuLiveProcessService
    ]
})
export class InnerMenuLiveProcessModule extends SiriusAppModule { }
